import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Sidenav from "ui/Sidenav";
import Footer from "ui/Footer";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import routes from "routes";
import { useCustomController } from "context";
import brand from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";

export default function App() {
  const [controller] = useCustomController();
  const { layout, sidenavColor, darkSidenav, darkMode, miniSidenav } = controller;
  const { pathname } = useLocation();
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }
      return null;
    });

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: "100vh",
          background: "#f7f7f5",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {layout === "dashboard" && (
          <Sidenav
            color={sidenavColor}
            brand={darkSidenav || darkMode ? brand : brandDark}
            brandName="The Stock Owner's Report"
            routes={routes}
          />
        )}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Routes>
            {getRoutes(routes)}
            <Route path="*" element={<Navigate to="/brokeragesAndAccounts" />} />
          </Routes>
        </Box>
        <Box
          sx={({ breakpoints, functions: { pxToRem } }) => ({
            background: "#f7f7f5",
            borderTop: "1px solid #d6d9de",
            py: 2,
            px: 3,
            mt: "auto",
            [breakpoints.up("xl")]: {
              marginLeft: layout === "dashboard" ? (miniSidenav ? pxToRem(120) : pxToRem(274)) : 0,
              transition: "margin-left 0.3s ease",
            },
          })}
        >
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
